import { render, staticRenderFns } from "./MBottomBar.vue?vue&type=template&id=d3d83534&scoped=true&"
import script from "./MBottomBar.vue?vue&type=script&lang=js&"
export * from "./MBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./MBottomBar.vue?vue&type=style&index=0&id=d3d83534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d83534",
  null
  
)

export default component.exports